import axios from "axios";
import { API_URL, getHeader } from "../config";

export const getHighlight = async () => {
  const { data } = await axios.get(API_URL + `/api/highlight/CCSDH`);

  return data;
};
export const getBirthdays = async () => {
  const { data } = await axios.get(API_URL + `/api/birthdays/CCSDH`);
  return data;
};
export const getNews = async () => {
  const { data } = await axios.get(API_URL + `/api/news/CCSDH`);

  return data;
};
export const getNewsInner = async () => {
  const { data } = await axios.get(API_URL + `/api/news/all/CCSDH`);

  return data;
};

export const getEvents = async () => {
  const { data } = await axios.get(API_URL + `/api/events/CCSDH`);

  return data;
};

export const getEventsinner = async () => {
  const { data } = await axios.get(API_URL + `/api/events/All/CCSDH`);

  return data;
};

export const getGallery = async () => {
  const { data } = await axios.get(API_URL + `/api/gallery/CCSDH`);
  return data;
};

export const getGalleryInner = async () => {
  const { data } = await axios.get(API_URL + `/api/gallery/All/CCSDH`);
  return data;
};

export const getSubGallery = async (id) => {
  console.log(id);
  const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);

  return data;
};

export const getNotification = async () => {
  const { data } = await axios.get(
    API_URL + `/api/notification/CCSDH`,
    getHeader()
  );

  return data;
};

export const getTopper = async () => {
  const { data } = await axios.get(API_URL + `/api/topper/CCSDH`, getHeader());
  return data;
};

export const getOnlineRegistration = async () => {
  const { data } = await axios.get(
    API_URL + `/api/onlineRegistration/CCSDH`,
    getHeader()
  );

  return data;
};

export const getPrincipalMessage = async () => {
  const { data } = await axios.get(
    API_URL + `/api/principalMessage/CCSDH`,
    getHeader()
  );
  return data;
};
export const getSlider = async () => {
  const { data } = await axios.get(API_URL + `/api/Slider/CCSDH`, getHeader());
  return data;
};

export const getVideoGallery = async () => {
  const { data } = await axios.get(
    API_URL + `/api/video/all/CCSDH`,
    getHeader()
  );
  return data;
};
export const getCircular = async () => {
  const { data } = await axios.get(
    API_URL + `/api/circular/all/CCSDH`,
    getHeader()
  );
  return data;
};
export const postTransferCertificate = async (name, admission) => {
  console.log(name, admission);

  const { data } = await axios.post(
    API_URL + `/api/tc/CCSDH`,
    { name, admission },
    getHeader()
  );
  return data;
};

export const form = async (formData, header, type) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/api/form/CCSDH/${type}`,
      formData,
      header
    );
    return data;
  } catch (error) {
    console.error("Error in form submission:", error);
    if (error.response) {
      console.error("Error response data:", error.response.data);
    }
    throw error;
  }
};
